const testimonials = [
  {
    quote:
      "Meridian's lead capture platform transformed how we engage customers at auto shows. At the Bronco Mountain activation alone, we captured over 16,000 interactions — and the real-time dashboard meant our team could pivot strategy on the fly. The quality of data we walked away with was unlike anything we'd seen from previous vendors.",
    author: "Sarah Mitchell",
    title: "Director of Experiential Marketing",
    company: "Ford Motor Company",
    event: "SEMA & Auto Show Circuit",
  },
  {
    quote:
      "We've used badge scanning at trade shows for years, but Meridian's integration with our existing Cvent setup was seamless. The progressive profiling feature was a game changer — attendees didn't have to fill out the same form at every activation, which kept satisfaction high and drop-off rates low.",
    author: "James Kowalski",
    title: "VP of Event Strategy",
    company: "Chevrolet",
    event: "Chicago Auto Show",
  },
  {
    quote:
      "Our EV launch events required multilingual support across three countries and the ability to work completely offline at outdoor venues. Meridian delivered on every front. The iOS app synced perfectly once connectivity returned, and we had complete data integrity across 20,000+ unique registrants.",
    author: "Elena Vasquez",
    title: "Head of Global Events",
    company: "Stellantis",
    event: "Global EV Launch Tour",
  },
  {
    quote:
      "The personalized follow-up emails triggered from survey responses drove a 34% open rate — more than double our usual benchmark. When someone told us they were interested in truck towing capacity at the show, they got a tailored email about exactly that. Meridian made it effortless.",
    author: "Derek Okafor",
    title: "Senior Manager, CRM & Loyalty",
    company: "Ram Trucks",
    event: "State Fair Activation Series",
  },
  {
    quote:
      "We needed a partner who understood the chaos of a live event floor. Meridian's team is battle-tested — they've seen it all. From QR code stations to brand ambassador tablets to kiosk deployments, every touchpoint worked flawlessly. The live leaderboard for our product specialists actually became a morale booster for the whole team.",
    author: "Tricia Hannigan",
    title: "Field Marketing Lead",
    company: "GMC",
    event: "National Truck Month Tour",
  },
  {
    quote:
      "What sets Meridian apart is the strategy behind the technology. They didn't just hand us software — they helped us design a smarter activation. Their 25+ years of experience showed at every stage, from pre-show planning to post-event reporting. We're already signed on for next year.",
    author: "Marcus Lee",
    title: "Event Experience Manager",
    company: "Toyota North America",
    event: "Los Angeles Auto Show",
  },
];

function Testimonials() {
  return (
    <>
      {/* Hero */}
      <section className="hero testimonials-hero">
        <div className="hero-content">
          <h1 className="hero-title">What Our Clients Say</h1>
          <p className="hero-subtitle">
            Trusted by leading automakers to power their most important event activations
          </p>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="testimonials-section">
        <div className="container">
          <h2 className="section-title">Client Testimonials</h2>
          <div className="testimonials-grid">
            {testimonials.map((t, i) => (
              <div className="testimonial-card" key={i}>
                <div className="testimonial-quote-mark">"</div>
                <p className="testimonial-quote">{t.quote}</p>
                <div className="testimonial-footer">
                  <div className="testimonial-avatar">
                    {t.author.split(' ').map((n) => n[0]).join('')}
                  </div>
                  <div className="testimonial-author-info">
                    <div className="testimonial-author">{t.author}</div>
                    <div className="testimonial-title">{t.title}</div>
                    <div className="testimonial-company">{t.company}</div>
                    <div className="testimonial-event">{t.event}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="testimonials-cta">
        <div className="container">
          <h2>Ready to Transform Your Event Experience?</h2>
          <p>Join the world's leading automakers who trust Meridian Event Tech to capture, connect, and convert.</p>
          <a href="/contact" className="cta-button">Get in Touch</a>
        </div>
      </section>
    </>
  );
}

export default Testimonials;
